import React, {useCallback, useEffect, useState} from 'react';
import css from "./Command.module.scss";
import trash from '../../../../images/big-trash.svg'
import arrow from '../../../../images/right-arrow.svg'
import userPlaceholder from '../../../../images/user-placeholder.png'
import circle from '../../../../images/blue-circle.svg'
import infoIcon from '../../../../images/red-info.svg'
import ReactTooltip from "react-tooltip";
import {useTranslation} from "react-i18next";
import {fromDateToStringDate} from "../../../../utils";
import {userApi} from "../../../../redux/user/user-api";

const CommandItem = ({user, setDeleteUser, isDark}) => {
  const [isShowInfo, setIsShowInfo] = useState(false)
  const {t} = useTranslation()
  const [avatar, setAvatar] = useState(null)
  const fetchFileInfo = useCallback(async (id) => {
    const response = await userApi.getFile(id)
    setAvatar(response !== null ? Buffer.from(response.data, 'binary').toString('base64') : null)
  }, [])
  useEffect(() => {
    if (user.crew_profile.image_link) {
      fetchFileInfo(user.crew_profile.image_link)
    }
  }, [])
  return (
    <>
      <ul onClick={() => setIsShowInfo(!isShowInfo)} className={css.command__row}>
        <li className={css.command__item}>
          <img src={avatar ? `data:image/png;base64,${avatar}` : userPlaceholder} alt="" className={css.command__img}/>
        </li>
        <li className={css.command__item}>{user.crew_profile?.first_name} {user.crew_profile?.last_name}</li>
        <li className={css.command__item}>{user.crew_email}</li>
        <li className={css.command__item}>{user.trips ? user.trips.length : '-'}</li>
        <li className={css.command__item}>
          <span>{user.miles_together ?? '-'}</span>
          <div className={css.command__buttons}>
            {/*{!user.crew_profile.name && <button data-tip data-for={user.crew_profile.email} className={css.command__infoBtn}>*/}
            {/*  <img src={infoIcon} alt=""/>*/}
            {/*</button>}*/}
            {/*<ReactTooltip className={'tooltip'} backgroundColor={'#F7F8FB'} id={user.crew_profile.email} place="top" effect="solid">*/}
            {/*  {t('notRegisteredInfo')}*/}
            {/*</ReactTooltip>*/}
            {/*<button onClick={setDeleteUser} className={css.command__delete}>*/}
            {/*  <img src={trash} alt=""/>*/}
            {/*</button>*/}
            <button className={css.command__arrow}>
              <img className={`${isShowInfo && 'rotate'}`} src={arrow} alt=""/>
            </button>
          </div>
        </li>
      </ul>
      {isShowInfo && <div className={css.command__info}>
        {user.trips.map((trip) => (
          <ul className={css.command__row}>
            <li className={css.command__item} >
              <div className={css.command__circle} >
                <img src={circle} alt=""/>
              </div>
            </li>
            <li className={css.command__item}>
              <span className="font400">{fromDateToStringDate(trip.start_date, true)}, {(new Date(trip.finish_date) - new Date(trip.start_date))/(24*3600*1000)} {t('days_short')}</span>
            </li>
            <li className={css.command__item}>
              <span className="font400">{trip.yacht_model.name} "{trip.yacht.name}"</span>
            </li>
            <li className={css.command__item}>
              {t('miles')}: <span className="font400">{trip.miles}</span>
            </li>
            <li className={`${css.command__item} justify-start`}>
              {t('marinaStart')}: <span className="font400">{trip.start_marina ? `${trip.start_marina.name},` : ''} {trip.start_country?.name}</span>
            </li>
          </ul>
        ))}
      </div>}
    </>
  );
};

export default React.memo(CommandItem);
